import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col text-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sr-only" })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col text-center mt-2" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Udstyrsliste")
  ])
], -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col text-center mt-2" }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldsComponent = _resolveComponent("FieldsComponent")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field, index) => {
          return (_openBlock(), _createElementBlock("div", null, [
            _createVNode(_component_FieldsComponent, {
              modelValue: _ctx.fields[index],
              "onUpdate:modelValue": ($event: any) => ((_ctx.fields[index]) = $event),
              "onUpdate:field": _ctx.fieldUpdated
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onUpdate:field"])
          ]))
        }), 256)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.fields.length <= 0)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_7, "Ingen Udstyr opsat for kontrakt " + _toDisplayString(_ctx.agreementID), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ], 64))
}